export default __webpack_public_path__ + "static/squarelogo-358b013c936f079823d9dcf31a2cb207.png";